import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class JobService {
	readonly url: string = 'Job';

	constructor(private http: HttpClient) {}

	public deleteActiveHangfireJob(job: any) {
		return this.http.delete<boolean>(`${this.url}/DeleteHangfireJob/${job.id}`);
	}

	public get(companyId: number, linkId: number): Observable<any[]> {
		return this.http.get<any[]>(this.url + '/' + companyId + '/' + linkId);
	}
}
